'use client'

import { PropsWithChildren } from 'react'

import { TRoomDetail, TSimpleReviewCount } from '@/entities/room'
import { cn } from '@/shared/lib'
import { Button, Dialog, Separator } from '@/shared/ui'

import { ReviewList } from './review-list'
import { ReviewScore } from './review-score'
import { SimpleReview } from './simple-review'

type Props = Pick<TRoomDetail, 'reviewList' | 'reviewScore'> & {
  roomSimpleReview: TSimpleReviewCount[]
}

export const ReviewDialogTrigger = ({
  children,
  reviewList,
  reviewScore,
  roomSimpleReview,
}: PropsWithChildren<Props>) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <ReviewDialog
        reviewList={reviewList}
        reviewScore={reviewScore}
        roomSimpleReview={roomSimpleReview}
      />
    </Dialog.Root>
  )
}

export const ReviewDialog = ({
  reviewList,
  reviewScore,
  roomSimpleReview,
}: Props) => {
  const hasSimpleReview = roomSimpleReview.length > 0

  return (
    <Dialog.Content className="@container h-[760px] gap-0 p-0">
      <Dialog.Header className="p-6">
        <Dialog.Title>후기</Dialog.Title>
      </Dialog.Header>
      <div className="scrollbar thick flex grow flex-col overflow-y-auto px-6">
        <ReviewScore
          reviewScore={reviewScore}
          className={cn('mb-6', hasSimpleReview && 'mb-4')}
        />
        {hasSimpleReview && (
          <>
            <SimpleReview simpleReviews={roomSimpleReview} />
            <Separator color="gray" className="my-6" />
          </>
        )}
        <ReviewList reviewList={reviewList} showAll />
      </div>
      <Dialog.Footer className="p-6">
        <Dialog.Close asChild>
          <Button size="large" color="secondary">
            닫기
          </Button>
        </Dialog.Close>
      </Dialog.Footer>
    </Dialog.Content>
  )
}
